import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import CustomSelect from "../../../../components/main_comps/custom_select";
import { colorWhite } from "../../../../../utility/constants/colorManager";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import {
  RESELLER,
  RUPEES,
  SETTLEMENT_CYCLES,
  SETTLEMENT_HOURLY,
  SETTLEMENT_INSTANT,
  SETTLEMENT_TPLUSONE,
  STATUS_CODE_200
} from "../../../../../utility/constants/valueConstants";
import { useSnackbar } from "notistack";
import {
  SS_ADMIN_ID,
  SS_EMAIL,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID
} from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { modififyDropdownServiceNameList } from "../../../../../services/fetchDropdownListData";
import CheckBoxInput from "../../../../components/ui_comps/CheckBoxInput";
import ComissionContainer from "../../../../components/ui_comps/ComissionContainer";
import { FLAT } from "../../../../../utility/constants/valueConstants";
// change
import SettlementContainer from "../../../../components/ui_comps/SettlementContainer";
import CommissionOnPayment from "../../../../components/ui_comps/CommissionOnPayment";
import {
  modifyCommissionRate,
  modifyCommissionSlabRate
} from "../../../../../utility/modifyRate";

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false,
  defaultChecked2
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px"
        }}
        defaultChecked2={defaultChecked2}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

function ServiceRate({
  onClickNext,
  onClickPrevious,
  reduxData,
  onClickCancel
}) {
  const [currentValue, setCurrentValue] = useState("Flat");
  const [serviceType, setServiceType] = useState(RUPEES);
  const [serviceProviderRate, setServiceProviderRate] = useState("");
  const [reseller, setReseller] = useState("");
  const [resellerRate, setResellerRate] = useState("");
  const [neokredRate, setNeokredRate] = useState("");
  const [clientRate, setClientRate] = useState([]);

  const [resellerName, setResellerName] = useState("");
  const [resellerData, setResellerData] = useState([]);
  const [createdBy, setCreatedBy] = useState({});
  const [adminId, setAdminId] = useState("");
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [flatData, setFlatData] = useState({});
  const [type, setType] = useState("");
  const [mechanism, setMechanism] = useState([]);
  const [mechanism2, setMechanism2] = useState(["cba"]);
  const [prefillComissionRate, setPrefillCommissionRate] = useState([]);
  const [zyromechanism, setZyroMechanism] = useState("cba");
  const [zyroUserId, setZyroUserId] = useState("");
  const [zyropass, setZyroPass] = useState("");
  const [vpaSubString, setVpaSubString] = useState("");
  const [prefundUrl, setPrefundUrl] = useState("");
  const [mcc, setMcc] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [onDemandSettlement, setOnDemandSettlement] = useState(false);
  const [settleToAccount, setSettleToAccount] = useState(false);
  const [isInternal, setIsInternal] = useState(false);
  const [voucherServiceType, setVoucherServiceType] = useState("");
  const [voucherBusinessType, setVoucherBusinessType] = useState("b2c");
  const [remitterAccountNumber, setRemitterAccountNumber] = useState("");
  const [remitterAccountIfsc, setRemitterAccountIfsc] = useState("");
  const [currentVal, setCurrentVal] = useState(false);

  const [settlementArray, setSettlementArray] = useState([]);

  const [method, setMethod] = useState("");
  const [settlementValue, setSettlementValue] = useState("");
  const [settlementCharges, setSettlementCharges] = useState("");
  const [impsArray, setImpsArray] = useState([]);
  const [rtgsarray, setRtgsarray] = useState([]);
  const [neftArray, setNeftArray] = useState([]);
  const [iftArray, setIftArray] = useState([]);
  const [upiArray, setUpiArray] = useState([]);
  const [cashfreMerchantId, setCashfreeMerchantId] = useState("");
  const [cashfreFundSourceId, setCashfreeFundSourceId] = useState("");

  const inputStyle = {
    maxWidth: 500,
    minWidth: 250,
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    width: 350
  };
  const containerStyle = {
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: 40,
    border: "1px solid #CBCACA",
    borderRadius: "5px"
  };

  const getData = async () => {
    const id = await secureStorage.getItem(SS_USER_HASH_ID);
    const role = await secureStorage.getItem(SS_ROLE);
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const email = await secureStorage.getItem(SS_EMAIL);
    const adminid = await secureStorage.getItem(SS_ADMIN_ID);

    setCreatedBy({ email, userName: firstName + " " + lastName });

    if (role?.toLocaleUpperCase() === RESELLER) {
      setResellerName(firstName + " " + lastName);
      setAdminId(adminid);
    }
    setUserId(id);
    setRole(role);
  };

  const getResellerList = () => {
    ApiRequestGet.getResellerList()
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setResellerData(modififyDropdownData(res.data));
        }
      })
      .catch((err) => {});
  };
  const modififyDropdownData = (data) => {
    let arr = [
      {
        label: "Select Reseller",
        value: "",
        commissionRate: "",
        commissionType: "",
        userRefId: ""
      }
    ];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.userId,
          label: val.firstName + " " + val.lastName,
          commissionRate: val?.comissionRate,
          commissionType: val?.comissionType,
          userRefId: val?.userRefId
        });
      });

    return arr;
  };
  useEffect(() => {
    getData();
    getResellerList();
  }, []);

  const [genericCommission, setGenericCommission] = useState([
    {
      type: "",
      commissionType: "",
      from: 0,
      to: 0,
      percentage: 0,
      flatAmount: 0
    }
  ]);

  const [commissionData, setCommissionData] = useState({
    commissionOnTransactionMode: {
      IMPS: [],
      RTGS: [],
      NEFT: [],
      IFT: [],
      UPI: []
    }
  });

  useEffect(() => {
    console.log(reduxData, "REDUX DATA");
    if (reduxData?.service?.serviceProviderRate) {
      setServiceProviderRate(reduxData?.service?.serviceProviderRate);
    }
    if (
      reduxData?.service?.serviceProviderRate &&
      reduxData?.service?.resellerRate &&
      reduxData?.service?.neokredRate &&
      reduxData?.service?.comissionRate &&
      reduxData?.service?.comissionType &&
      reduxData?.resellerName
    ) {
      setCurrentValue(reduxData?.service?.comissionType);
      setType(reduxData?.service?.comissionType);
      setServiceProviderRate(reduxData?.service?.serviceProviderRate);
      setReseller({
        label: reduxData?.resellerName,
        value: reduxData?.userRefId,
        userRefId: reduxData?.rootReferenceId
      });
      setResellerRate(reduxData?.service?.resellerRate);
      setNeokredRate(reduxData?.service?.neokredRate);
      let commissionRate = reduxData?.service?.comissionRate;

      if (reduxData?.service?.comissionType === FLAT) {
        setFlatData(commissionRate[0]);
      } else {
        setClientRate(commissionRate);
      }
      setVpaSubString(reduxData?.service?.vpaSubString);
      setMcc(reduxData?.service?.mcc);
      setPrefillCommissionRate(commissionRate);
      setIsInternal(reduxData?.service?.isInternal);
      setMechanism(reduxData?.service?.mechanism);
      if (reduxData.service.serviceProviderName?.toUpperCase() !== "NEOKRED") {
        if (reduxData?.service?.mechanism.includes("cba")) {
          setZyroMechanism("cba");
          let temp = [];
          temp.push("cba");
          setMechanism2(temp);
        }
        if (reduxData?.service?.mechanism.includes("van")) {
          setZyroMechanism("van");
          let temp = [];
          temp.push("van");
          setMechanism2(temp);
          setZyroUserId(reduxData?.service?.zyroUserId);
          setZyroPass(reduxData?.service?.zyropass);
        }
      }
    }
    if (
      reduxData?.service?.serviceType?.toUpperCase() === "VAN" &&
      (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
        reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC")
    ) {
      setOnDemandSettlement(reduxData?.service?.onDemandSettlement);
      setSettleToAccount(reduxData?.service?.settleToAccount);
    }

    if (
      reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
      reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER"
    ) {
      setSettlementCharges(reduxData?.service?.settlementCharges);
      setVoucherServiceType(reduxData.service.program);
      setVoucherBusinessType(reduxData.service.voucherBusinessType);
      if (reduxData?.service?.voucherBusinessType === "b2b") {
        setRemitterAccountIfsc("");
        setRemitterAccountNumber("");
      }
    }

    if (
      reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" &&
      reduxData?.service?.serviceType?.toUpperCase() === "PAYIN"
    ) {
      let arra = [];
      arra.push(reduxData?.service?.settlementDetails);
      setMethod(reduxData?.service?.settlementDetails?.method);
      setMethod(reduxData?.service?.settlementDetails?.instantMethod);
      setSettlementArray(arra);
    }
    if (
      reduxData?.service?.serviceProviderName?.toUpperCase() === "CASHFREE" &&
      reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT"
    ) {
      setCashfreeMerchantId(reduxData?.service?.cashfree_merchant_id);
      setCashfreeFundSourceId(reduxData?.service?.cashfree_fundsource_id);
    }
  }, [reduxData]);

  // useEffect(() => {
  //   if (
  //     impsArray.length > 0 ||
  //     rtgsarray.length > 0 ||
  //     neftArray.length > 0 ||
  //     iftArray.length > 0
  //   ) {
  //     setCommissionData((prevData) => ({
  //       ...prevData,
  //       commissionOnTransactionMode: {
  //         IMPS: impsArray,
  //         RTGS: rtgsarray,
  //         NEFT: neftArray,
  //         IFT: iftArray
  //       }
  //     }));
  //   }
  // }, [impsArray, rtgsarray, neftArray, iftArray]);

  useEffect(() => {
    if (
      impsArray.length > 0 ||
      rtgsarray.length > 0 ||
      neftArray.length > 0 ||
      iftArray.length > 0 ||
      (reduxData?.service?.serviceProviderName?.toUpperCase() === "CASHFREE" &&
        upiArray.length > 0) // Include UPI only for Cashfree
    ) {
      setCommissionData((prevData) => ({
        ...prevData,
        commissionOnTransactionMode: {
          IMPS: impsArray,
          RTGS: rtgsarray,
          NEFT: neftArray,
          IFT: iftArray,
          ...(reduxData?.service?.serviceProviderName?.toUpperCase() ===
            "CASHFREE" && { UPI: upiArray }) // Conditionally add UPI
        }
      }));
    }
  }, [impsArray, rtgsarray, neftArray, iftArray, upiArray]);

  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        marginTop: "20px",
        position: "absolute"
      }}
    >
      <p style={styles.title}>Service Rate</p>
      <p style={styles.p1}>Enter the NK rate</p>
      <div
        style={{
          margin: "10px 0 20px 0",
          height: "1px",
          background: "#38369C"
        }}
      ></div>
      {/* <div
        style={{
          fontWeight: "400",
          fontSize: "16px",
          color: "#1E2234",
          marginBottom: 20,
        }}
      >
        Enter the Rate
      </div> */}
      {/* <div
        style={{
          display: "flex",
          width: 225,
          justifyContent: "space-between",
          marginBottom: 20,
          gap: 3,
        }}
      >
        <div
          style={{
            padding: "5px 3px",
            borderRadius: 5,
            boxShadow:
              currentValue === "Flat" ? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "",
            backgroundColor:
              currentValue === "Flat" ? "#F5F6FA" : "rgba(255, 255, 255, 1)",
          }}
        >
          <RadioButton
            id="flat"
            name={"flat_radio"}
            title="Flat"
            value={"Flat"}
            onChange={(val) => {
              setCurrentValue(val.target.value);
            }}
            defaultChecked={currentValue === "Flat"}
            style={{
              margin: "0px 10px",
            }}
          />
        </div>
        <div
          style={{
            padding: "5px 3px",
            borderRadius: 5,
            boxShadow:
              currentValue === "Slab" ? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "",
            backgroundColor:
              currentValue === "Slab" ? "#F5F6FA" : "rgba(255, 255, 255, 1)",
          }}
        >
          <RadioButton
            id="slab"
            name={"flat_radio"}
            title="Slab"
            value={"Slab"}
            onChange={(val) => {
              setCurrentValue(val.target.value);
            }}
            defaultChecked={currentValue === "Slab"}
            style={{
              margin: "0px 10px",
            }}
          />
        </div>
      </div> */}

      {/* <div
        style={{
          display: "flex",
          width: 208,
          justifyContent: "space-between",
          marginBottom: 20,
          gap: 1,
        }}
      >
        <div
          style={{
            padding: "5px 3px",
            borderRadius: 5,
            boxShadow:
              serviceType === RUPEES ? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "",
            backgroundColor:
              serviceType === RUPEES ? "#F5F6FA" : "rgba(255, 255, 255, 1)",
          }}
        >
          <RadioButton
            id="rupees"
            name={"rupees_radio"}
            title="₹"
            value={RUPEES}
            onChange={(val) => {
              setClientRate("");
              setServiceType(val.target.value);
            }}
            defaultChecked={serviceType === RUPEES}
            style={{
              margin: "0px 10px",
            }}
          />
        </div>
        <div
          style={{
            padding: "5px 3px",
            borderRadius: 5,
            boxShadow:
              serviceType === PERCENTAGE
                ? "0px 4px 4px rgba(0, 0, 0, 0.25)"
                : "",
            backgroundColor:
              serviceType === PERCENTAGE ? "#F5F6FA" : "rgba(255, 255, 255, 1)",
          }}
        >
          <RadioButton
            id="percentage"
            name={"rupees_radio"}
            title="%"
            value={PERCENTAGE}
            onChange={(val) => {
              setClientRate("");
              setServiceType(val.target.value);
            }}
            defaultChecked={serviceType === PERCENTAGE}
            style={{
              margin: "0px 10px",
            }}
          />
        </div>
      </div> */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          padding: "20px 20px 20px 20px",
          gap: 20,
          border: "1px solid #CBCACA",
          borderRadius: "5px",
          backgroundColor: colorWhite,
          marginBottom: 20
        }}
      >
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>
            Service Provider Rate
          </label>
          <CustomInput
            value={serviceProviderRate}
            // onChange={(data) => {
            //   setServiceProviderRate(data);
            // }}
            inputcomponentStyles={{ ...inputStyle }}
            disabled={true}
            placeholder="Service Provider Rate"
            validator="number"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
          />
        </div>
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Reseller</label>
          <CustomSelect
            placeholder="Select Reseller"
            style={{
              ...containerStyle,
              backgroundColor: "white",
              position: ""
            }}
            value={reseller}
            options={resellerData}
            onChange={(data) => {
              setReseller(data);
            }}
          />
        </div>
        {/* {serviceType === RUPEES ? (
          <div style={{ minWidth: "150px" }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>Reseller Rate</label>
            <CustomInput
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the amount"
              type="input"
              validator="amount"
              inputStyles={{
                ...containerStyle,
                ...containerStyle1,
                marginBottom: 0,
              }}
              //value={reduxData?.security ? reduxData?.security : ""}
              value={resellerRate}
              onChange={(data) => {
                setResellerRate(data);
              }}
            />
          </div>
        ) : ( */}
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Reseller Rate</label>
          <CustomInput
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Eg : 20%"
            type="input"
            validator="percentageDecimal"
            inputStyles={{
              ...containerStyle
            }}
            value={resellerRate}
            onChange={(data) => {
              setResellerRate(data);
            }}
            maxLength={5}
          />
        </div>

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER" && (
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Settlement Charges
              </label>
              <CustomInput
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Eg : 20%"
                type="input"
                validator="percentageDecimal"
                inputStyles={{
                  ...containerStyle
                }}
                value={settlementCharges}
                onChange={(data) => {
                  setSettlementCharges(data);
                }}
                maxLength={5}
              />
            </div>
          )}
        {/* )} */}
        {/* {serviceType === RUPEES ? (
          <div style={{ minWidth: "150px" }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>Neokred Rate</label>
            <CustomInput
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter the amount"
              type="input"
              validator="amount"
              inputStyles={{
                ...containerStyle,
                ...containerStyle1,
              }}
              //value={reduxData?.security ? reduxData?.security : ""}
              onChange={(data) => {
                setNeokredRate(data);
              }}
              value={neokredRate}
            />
          </div>
        ) : ( */}
        <div style={{ minWidth: "150px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Neokred Rate</label>
          <CustomInput
            onChange={(data) => {
              setNeokredRate(data);
            }}
            value={neokredRate}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Eg : 30%"
            validator="percentageDecimal"
            type="input"
            inputStyles={{
              ...containerStyle
            }}
            maxLength={5}
          />
        </div>
        {/* {currentValue === "Flat" ? (
          <>
            {serviceType === RUPEES ? (
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Client Rate
                </label>
                <CustomInput
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Client Rate = Nk Rate + Reseller Rate"
                  type="input"
                  validator="amount"
                  inputStyles={{
                    ...containerStyle,
                    ...containerStyle1,
                  }}
                  //value={reduxData?.security ? reduxData?.security : ""}
                  onChange={(data) => {
                    setClientRate(data);
                  }}
                  value={clientRate}
                />
              </div>
            ) : (
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Client rate
                </label>
                <CustomInput
                  value={clientRate}
                  onChange={(data) => {
                    setClientRate(data);
                  }}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Client Rate = Nk rate + reseller Rate"
                  validator="number"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                  maxLength={2}
                />
              </div>
            )}
          </>
        ) : ( */}

        {reduxData?.service?.serviceProviderName?.toUpperCase() ===
          "CASHFREE" &&
          reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Cashfree Merchant ID
                </label>
                <CustomInput
                  onChange={(data) => {
                    setCashfreeMerchantId(data);
                  }}
                  value={cashfreMerchantId}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Cashfree Merchant ID"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Cashfree Fundsource ID
                </label>
                <CustomInput
                  onChange={(data) => {
                    setCashfreeFundSourceId(data);
                  }}
                  value={cashfreFundSourceId}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Cashfree Fundsource ID"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
            </>
          )}
        {reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" &&
          (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "CASHFREE") && (
            <div>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Select your commission
              </label>

              <div className="flex">
                <RadioButton
                  id="generic"
                  name={"generic"}
                  title="generic"
                  value="generic"
                  onChange={(val) => {
                    setCurrentVal(val.target.value);
                  }}
                  defaultChecked={currentVal === "generic"}
                />

                <RadioButton
                  id="commissionOnPayment"
                  name={"commissionOnPayment"}
                  title="commissionOnTransaction"
                  // COMMISSION_ON_TRANSACTION
                  value="commission_on_transaction" // Corrected value attribute
                  onChange={(val) => {
                    setCurrentVal(val.target.value);
                  }}
                  defaultChecked={currentVal === "commission_on_transaction"}
                  style={{
                    margin: "0px 10px"
                  }}
                />
              </div>
              {currentVal === "generic" && (
                <div className="py-4">
                  <ComissionContainer
                    styles={{
                      width: "343px",
                      background: "white",
                      minHeight: "71px",
                      borderRadius: "6px",
                      border: "1px solid #CBCACA"
                    }}
                    innerStyles={{
                      marginLeft: "-12px",
                      marginTop: "-8px"
                    }}
                    onClickNext={(data, flatData, type) => {
                      const modifiedData = modifyCommissionRate(
                        data,
                        flatData,
                        type
                      );
                      console.log(modifiedData, "modifiedData");
                      setGenericCommission(modifiedData);
                    }}
                    isSlabRequired={true}
                    rate={
                      reduxData?.service?.commissionRate ?? prefillComissionRate
                    }
                    // type={reduxData?.service?.comissionType ?? type}
                    slabData={reduxData?.service?.comissionRate}
                    onClickDelete={(data) => {
                      if (data.length === 0) {
                        setClientRate([]);
                      }
                    }}
                  />
                </div>
              )}
              {currentVal === "commission_on_transaction" && (
                <div className="flex flex-wrap justify-center mt-10 space-x-4">
                  <div className="py-4 max-w-sm">
                    <CommissionOnPayment
                      styles={{
                        background: "white",
                        minHeight: "71px",
                        borderRadius: "6px",
                        border: "1px solid #CBCACA"
                      }}
                      title={"IMPS"}
                      onClickNext={(data, flatData, type, handleDataUpdate) => {
                        console.log(data, flatData, type, "IMPS DATA");

                        if (type === "flat") {
                          const modifiedData = modifyCommissionRate(
                            data,
                            flatData,
                            type
                          );
                          console.log(modifiedData, "modifiedData----flat");
                          if (Array.isArray(modifiedData)) {
                            setImpsArray(modifiedData);
                          } else if (typeof modifiedData === "object") {
                            setImpsArray([modifiedData]);
                          }
                        } else if (type !== "flat") {
                          const slabModifiedData = modifyCommissionSlabRate(
                            data,
                            type
                          );
                          console.log(slabModifiedData, "slabModifiedData");

                          setImpsArray(slabModifiedData);
                        }
                      }}
                    />
                  </div>

                  <div className="py-4 max-w-sm">
                    <CommissionOnPayment
                      styles={{
                        background: "white",
                        minHeight: "71px",
                        borderRadius: "6px",
                        border: "1px solid #CBCACA"
                      }}
                      title={"RTGS"}
                      onClickNext={(data, flatData, type, handleDataUpdate) => {
                        console.log(data, flatData, type, "RTGS DATA");

                        if (type === "flat") {
                          const modifiedData = modifyCommissionRate(
                            data,
                            flatData,
                            type
                          );

                          if (Array.isArray(modifiedData)) {
                            setRtgsarray(modifiedData);
                          } else if (typeof modifiedData === "object") {
                            setRtgsarray([modifiedData]); // If it's an object, wrap it in an array
                          }
                        } else if (type !== "flat") {
                          console.log("inside slab condition");
                          const slabModifiedData = modifyCommissionSlabRate(
                            data,
                            type
                          );
                          console.log(slabModifiedData, "slabModifiedData");

                          setRtgsarray(slabModifiedData);
                        }
                      }}
                    />
                  </div>

                  <div className="py-4 max-w-sm">
                    <CommissionOnPayment
                      styles={{
                        background: "white",
                        minHeight: "71px",
                        borderRadius: "6px",
                        border: "1px solid #CBCACA"
                      }}
                      title={"NEFT"}
                      onClickNext={(data, flatData, type, handleDataUpdate) => {
                        console.log(data, flatData, type, "NEFT DATA");

                        if (type === "flat") {
                          const modifiedData = modifyCommissionRate(
                            data,
                            flatData,
                            type
                          );

                          if (Array.isArray(modifiedData)) {
                            setNeftArray(modifiedData);
                          } else if (typeof modifiedData === "object") {
                            setNeftArray([modifiedData]);
                          }
                        } else if (type !== "flat") {
                          console.log("inside slab condition");
                          const slabModifiedData = modifyCommissionSlabRate(
                            data,
                            type
                          );
                          console.log(slabModifiedData, "slabModifiedData");

                          setNeftArray(slabModifiedData);
                        }
                      }}
                    />
                  </div>

                  <div className="py-4 max-w-sm">
                    <CommissionOnPayment
                      styles={{
                        background: "white",
                        minHeight: "71px",
                        borderRadius: "6px",
                        border: "1px solid #CBCACA"
                      }}
                      title={"IFT"}
                      onClickNext={(data, flatData, type) => {
                        console.log(data, flatData, type, "IFT DATA");

                        if (type === "flat") {
                          const modifiedData = modifyCommissionRate(
                            data,
                            flatData,
                            type
                          );
                          if (Array.isArray(modifiedData)) {
                            setIftArray(modifiedData);
                          } else if (typeof modifiedData === "object") {
                            setIftArray([modifiedData]);
                          }
                        } else if (type !== "flat") {
                          console.log("inside slab condition");
                          const slabModifiedData = modifyCommissionSlabRate(
                            data,
                            type
                          );
                          console.log(slabModifiedData, "slabModifiedData");

                          setIftArray(slabModifiedData);
                        }
                      }}
                    />
                  </div>
                  {reduxData?.service?.serviceType?.toUpperCase() ===
                    "PAYOUT" &&
                    reduxData?.service?.serviceProviderName?.toUpperCase() ===
                      "CASHFREE" && (
                      <>
                        <div className="py-4 max-w-sm">
                          <CommissionOnPayment
                            styles={{
                              background: "white",
                              minHeight: "71px",
                              borderRadius: "6px",
                              border: "1px solid #CBCACA"
                            }}
                            title={"UPI"}
                            onClickNext={(data, flatData, type) => {
                              console.log(data, flatData, type, "UPI DATA");

                              if (type === "flat") {
                                const modifiedData = modifyCommissionRate(
                                  data,
                                  flatData,
                                  type
                                );
                                if (Array.isArray(modifiedData)) {
                                  setUpiArray(modifiedData);
                                } else if (typeof modifiedData === "object") {
                                  setUpiArray([modifiedData]);
                                }
                              } else if (type !== "flat") {
                                console.log("inside slab condition");
                                const slabModifiedData =
                                  modifyCommissionSlabRate(data, type);
                                console.log(
                                  slabModifiedData,
                                  "slabModifiedData"
                                );
                                setUpiArray(slabModifiedData);
                              }
                            }}
                          />
                        </div>
                      </>
                    )}
                </div>
              )}
            </div>
          )}

        {/* FOR EVERYOONE EXPECT AXIS PAYOUT */}
        {(reduxData?.service?.serviceProviderName?.toUpperCase() !== "AXIS" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() !==
            "CASHFREE") &&
          reduxData?.service?.serviceType?.toUpperCase() !== "PAYOUT" && (
            <div className="py-4">
              <ComissionContainer
                styles={{
                  width: "343px",
                  background: "white",
                  minHeight: "71px",
                  borderRadius: "6px",
                  border: "1px solid #CBCACA"
                }}
                innerStyles={{
                  marginLeft: "-12px",
                  marginTop: "-8px"
                }}
                onClickNext={(data, flatData, type) => {
                  if (data.length > 0) {
                    setClientRate(data);
                  }

                  if (flatData) {
                    setFlatData(flatData);
                  }
                  if (type) {
                    setType(type?.toUpperCase());
                  }
                }}
                isSlabRequired={true}
                rate={
                  reduxData?.service?.commissionRate ?? prefillComissionRate
                }
                type={reduxData?.service?.comissionType ?? type}
                slabData={reduxData?.service?.comissionRate}
                onClickDelete={(data) => {
                  if (data.length === 0) {
                    setClientRate([]);
                  }
                }}
              />
            </div>
          )}

        {/* FOR AXIS PAYOUT */}
        {reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" &&
          reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Prefund URL
                </label>
                <CustomInput
                  onChange={(data) => {
                    setPrefundUrl(data);
                  }}
                  value={prefundUrl}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Prefund URL"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                  // maxLength={20}
                />
              </div>
            </>
          )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "EQUITAS" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VAN" && (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap"
                }}
                innerStyles={{
                  marginLeft: "-12px",
                  marginTop: "-8px"
                }}
              >
                <div style={{ marginTop: 20, marginRight: 20 }}>
                  <CheckBoxInput
                    title="Internal"
                    value={isInternal}
                    onChange={(event) => {
                      const isChecked = event.target.checked;
                      setIsInternal(isChecked);
                    }}
                    defaultChecked={isInternal}
                  />
                </div>
              </div>
            </>
          )}
        {/* NEOKRED AND VOUCHER */}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER" && (
            <>
              <div>
                <label
                  htmlFor="program"
                  style={{ fontSize: 14, lineHeight: 2 }}
                >
                  Voucher Business Solution Type
                </label>
                <div
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #CBCACA",
                    width: "343px",
                    background: "white",
                    minHeight: "71px",
                    justifyContent: "center",
                    alignContent: "center"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      marginTop: 20,
                      gap: 50,
                      marginBottom: "20px"
                    }}
                  >
                    <RadioButton
                      id="b2c"
                      name="voucherBusinessType"
                      title="B2C"
                      value={voucherBusinessType}
                      onChange={() => {
                        setVoucherBusinessType("b2c");
                        setVoucherServiceType("");
                        setRemitterAccountNumber("");
                        setRemitterAccountIfsc("");
                      }}
                      defaultChecked={voucherBusinessType == "b2c"}
                    />
                    <RadioButton
                      id="b2b"
                      name="voucherBusinessType"
                      title="B2B"
                      value={voucherBusinessType}
                      onChange={() => {
                        setVoucherBusinessType("b2b");
                        setVoucherServiceType("");
                        setRemitterAccountNumber("");
                        setRemitterAccountIfsc("");
                      }}
                      defaultChecked={voucherBusinessType == "b2b"}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "NEOKRED" &&
          reduxData?.service?.serviceType?.toUpperCase() === "VOUCHER" && (
            <>
              {voucherBusinessType === "b2c" ? (
                <div>
                  <label
                    htmlFor="program"
                    style={{ fontSize: 14, lineHeight: 2 }}
                  >
                    Program
                  </label>
                  <div
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #CBCACA",
                      width: "343px",
                      background: "white",
                      minHeight: "71px",
                      justifyContent: "center",
                      alignContent: "center"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        marginTop: 20,
                        gap: 50,
                        marginBottom: "20px"
                      }}
                    >
                      <RadioButton
                        id="fino"
                        name="voucherServiceType"
                        title="Fino"
                        value={voucherServiceType}
                        onChange={() => {
                          setVoucherServiceType("fino");
                        }}
                        defaultChecked={voucherServiceType == "fino"}
                      />
                      <RadioButton
                        id="idfc"
                        name="voucherServiceType"
                        title="Idfc"
                        value={voucherServiceType}
                        onChange={() => {
                          setVoucherServiceType("idfc");
                        }}
                        defaultChecked={voucherServiceType == "idfc"}
                      />
                    </div>
                  </div>
                </div>
              ) : voucherBusinessType === "b2b" ? (
                <div>
                  <div style={{ minWidth: "150px" }}>
                    <label style={{ fontSize: 14, lineHeight: 2 }}>
                      Remitter Account No
                    </label>
                    <CustomInput
                      value={remitterAccountNumber}
                      onChange={(data) => {
                        setRemitterAccountNumber(data);
                      }}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Remitter Acc No."
                      validator="accountNumber"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>
                  <div style={{ minWidth: "150px" }}>
                    <label style={{ fontSize: 14, lineHeight: 2 }}>
                      Remitter Account Ifsc
                    </label>
                    <CustomInput
                      value={remitterAccountIfsc}
                      onChange={(data) => {
                        setRemitterAccountIfsc(data);
                      }}
                      inputcomponentStyles={{ ...inputStyle }}
                      placeholder="Remitter Acc Ifsc"
                      validator="ifscCode"
                      type="input"
                      inputStyles={{
                        ...containerStyle
                      }}
                    />
                  </div>
                </div>
              ) : null}
            </>
          )}

        {reduxData?.service?.serviceProviderName?.toUpperCase() === "FINO" && (
          <>
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Vpa Sub String
              </label>
              <CustomInput
                onChange={(data) => {
                  setVpaSubString(data);
                }}
                value={vpaSubString}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Vpa Substring"
                validator={"alphaNum2"}
                type="input"
                inputStyles={{
                  ...containerStyle
                }}
                maxLength={20}
              />
            </div>

            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Mcc Code</label>
              <CustomInput
                onChange={(data) => {
                  setMcc(data);
                }}
                value={mcc}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mcc Code"
                validator={"number"}
                type="input"
                inputStyles={{
                  ...containerStyle
                }}
                maxLength={4}
              />
            </div>
          </>
        )}

        {(reduxData?.service?.serviceProviderName?.toUpperCase() === "IDFC" &&
          reduxData?.service?.serviceType?.toUpperCase() === "PAYIN") ||
          (reduxData?.service?.serviceType?.toUpperCase() === "VAN-UPI" && (
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Mcc Code</label>
              <CustomInput
                onChange={(data) => {
                  setMcc(data);
                }}
                value={mcc}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Mcc Code"
                validator={"number"}
                type="input"
                inputStyles={{
                  ...containerStyle
                }}
                maxLength={4}
              />
            </div>
          ))}

        {(reduxData?.service?.serviceProviderName?.toUpperCase() === "KOPAY" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() === "FINO" ||
          reduxData?.service?.serviceProviderName?.toUpperCase() ===
            "1PAY") && (
          <div
            style={{
              maxWidth: "343px",
              display: "flex",
              marginTop: "10px",
              alignItems: "center"
            }}
          >
            <CheckBoxInput
              title="VBA"
              value={"vba"}
              defaultChecked={mechanism?.includes("vba")}
              onChange={(val) => {
                if (mechanism?.includes("vba")) {
                  let arr = mechanism?.filter((o) => o !== "vba");
                  setMechanism(arr);
                } else {
                  setMechanism([...mechanism, val.target.value]);
                }
              }}
            />
            <CheckBoxInput
              title="QR"
              value={"qr"}
              defaultChecked={mechanism?.includes("qr")}
              onChange={(val) => {
                if (mechanism?.includes("qr")) {
                  let arr = mechanism?.filter((o) => o !== "qr");
                  setMechanism(arr);
                } else {
                  setMechanism([...mechanism, val.target.value]);
                }
              }}
            />
          </div>
        )}
        {reduxData?.service?.serviceType?.toUpperCase() === "VAN" &&
          (reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "IDFC") && (
            <div
              style={{
                maxWidth: "343px",
                display: "flex",
                marginTop: "10px",
                alignItems: "center"
              }}
            >
              <CheckBoxInput
                title="onDemandSettlement"
                value={onDemandSettlement}
                onChange={(event) => {
                  const isChecked = event.target.checked;
                  setOnDemandSettlement(isChecked);
                }}
              />
              <CheckBoxInput
                title="settleToAccount"
                value={settleToAccount}
                onChange={(event) => {
                  const isChecked = event.target.checked;
                  setSettleToAccount(isChecked);
                }}
              />
            </div>
          )}
        {reduxData?.service?.serviceType?.toUpperCase() === "PAYOUT" &&
          (reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() === "AXIS" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "CASHFREE" ||
            reduxData?.service?.serviceProviderName?.toUpperCase() ===
              "IDFC") && (
            <div
              style={{
                display: "flex",
                marginTop: 15,
                gap: 50,
                marginBottom: "20px"
              }}
            >
              <RadioButton
                id="yes"
                name="yes_radio"
                title="Connected Banking"
                value="cba"
                onChange={(val) => {
                  setZyroMechanism(val.target.value);
                  mechanism2.pop();
                  let temp = [];
                  temp.push(val.target.value);
                  setMechanism2(temp);
                  setZyroPass("");
                  setZyroUserId("");
                }}
                defaultChecked={zyromechanism === "cba"}
              />
              <RadioButton
                id="no"
                name="yes_radio"
                title="Virtual Account"
                value="van"
                onChange={(val) => {
                  setZyroMechanism(val.target.value);
                  mechanism2.pop();
                  let temp = [];
                  temp.push(val.target.value);
                  setMechanism2(temp);
                }}
                defaultChecked={zyromechanism === "van"}
              />
            </div>
          )}
        {zyromechanism === "van" &&
          reduxData?.service?.serviceProviderName?.toUpperCase() === "ZYRO" && (
            <>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>User ID</label>
                <CustomInput
                  onChange={(data) => {
                    setZyroUserId(data);
                  }}
                  value={zyroUserId}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="User ID"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
              <div style={{ minWidth: "150px" }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>Password</label>
                <CustomInput
                  onChange={(data) => {
                    setZyroPass(data);
                  }}
                  value={zyropass}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="Password"
                  type="input"
                  inputStyles={{
                    ...containerStyle
                  }}
                />
              </div>
            </>
          )}

        {/* AFTER THIS */}

        {reduxData?.service?.serviceType?.toUpperCase() === "PAYIN" &&
          reduxData?.service?.serviceProviderName?.toUpperCase() === "NPST" && (
            <div style={{ minWidth: "150px" }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Settlment Mode
              </label>
              <SettlementContainer
                styles={{
                  width: "100%",
                  background: "white",
                  minHeight: "71px",
                  borderRadius: "6px",
                  border: "1px solid #CBCACA"
                }}
                innerStyles={{
                  marginLeft: "-12px",
                  marginTop: "-8px"
                }}
                onClickNext={(data, flatData, type) => {
                  if (typeof data === "object") {
                    console.log(typeof data, "****OK****", data);

                    setSettlementArray(data);
                    setSettlementValue(data);
                  }
                  if (typeof data.flatSettlementData === "object") {
                    setSettlementValue(data);
                    setSettlementArray(data);
                  }

                  if (type) {
                    setMethod(type);
                  }
                }}
                isSlabRequired={true}
                rate={
                  reduxData?.service?.commissionRate ?? prefillComissionRate
                }
                type={reduxData?.service?.comissionType ?? type}
                settlementData={reduxData?.service?.settlementDetails ?? null}
                slabData={
                  // reduxData?.service?.comissionType === "slab" ??
                  reduxData?.service?.comissionRate
                }
                onClickDelete={(data) => {
                  if (data.length === 0) {
                    setClientRate([]);
                  }
                }}
              />
            </div>
          )}
      </div>

      <div
        style={{
          display: "flex",
          marginTop: "20px",
          marginBottom: 20
        }}
      >
        <div>
          <CustomButton
            title="Cancel"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickCancel}
          />
        </div>
        <div>
          <CustomButton
            title="Previous"
            styles={{ background: "#FDFDFD", margin: "0 15px 0 0" }}
            textStyles={{
              color: "#1E2234",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={onClickPrevious}
          />
        </div>
        <div>
          <CustomButton
            title="Next"
            styles={{ background: "#38369C" }}
            textStyles={{
              color: "#FDFDFD",
              fontWeight: "500",
              fontSize: "16px"
            }}
            onClick={() => {
              const exp = /^\d{1,2}(?:\.\d{1,2})?$/;
              const rupeesRegex = /^\d+(\.\d+)?$/;

              console.log(type?.toUpperCase(), "TYPEE");

              let ServiceProvider =
                reduxData?.service?.serviceProviderName?.toUpperCase();
              let servicetype = reduxData?.service?.serviceType?.toUpperCase();
              console.log(ServiceProvider, servicetype, "32");
              //condition for selecting mechanism

              if (
                (ServiceProvider !== "CASHFREE" ||
                  ServiceProvider !== "AXIS") &&
                servicetype !== "PAYOUT"
              ) {
                console.log(
                  (ServiceProvider !== "CASHFREE" ||
                    ServiceProvider !== "AXIS") &&
                    servicetype === "PAYOUT",
                  "condition 2"
                );
                if (type?.toUpperCase() === "FLAT") {
                  //condition to check if type is FLAT and values are valid or not
                  if (flatData?.value === "" || flatData?.type === undefined) {
                    enqueueSnackbar("Please fill all fields", {
                      variant: "error"
                    });
                    return;
                  }

                  if (flatData?.type === "RUPEES") {
                    if (!rupeesRegex.test(flatData?.value)) {
                      enqueueSnackbar("Please add appropriate value", {
                        variant: "error"
                      });
                      return;
                    }
                  }

                  if (flatData?.type === "PERCENTAGE") {
                    if (!exp.test(flatData?.value)) {
                      enqueueSnackbar("Please add appropriate value", {
                        variant: "error"
                      });
                      return;
                    }
                  }
                }

                //condition to check if type is SLAB and values are valid or not
                if (type?.toUpperCase() === "SLAB") {
                  if (clientRate.length === 0) {
                    enqueueSnackbar("Please fill all fields", {
                      variant: "error"
                    });
                    return;
                  }

                  for (const slabValues of clientRate) {
                    if (
                      slabValues?.value === "" ||
                      slabValues?.from === "" ||
                      slabValues?.to === ""
                    ) {
                      enqueueSnackbar("Please fill all fields", {
                        variant: "error"
                      });
                      return;
                    }

                    if (slabValues?.type === "RUPEES") {
                      if (!rupeesRegex.test(slabValues?.value)) {
                        enqueueSnackbar("Please add appropriate value", {
                          variant: "error"
                        });
                        return;
                      }
                    }
                    if (slabValues?.type === "PERCENTAGE") {
                      if (!exp.test(slabValues?.value)) {
                        enqueueSnackbar("Please add appropriate value", {
                          variant: "error"
                        });
                        return;
                      }
                    }
                  }
                }
              }

              //condition to check neokred rate,reseller rate is valid or not
              var neokredRatetest = exp.test(neokredRate);
              var resellerRateTest = exp.test(resellerRate);
              var settlementChargesTest = exp.test(settlementCharges);

              if (!neokredRatetest || !resellerRateTest) {
                enqueueSnackbar("Please Enter Valid rate", {
                  variant: "error"
                });
                return;
              }

              if (ServiceProvider === "FINO") {
                if (vpaSubString === undefined || vpaSubString.length === 0) {
                  enqueueSnackbar("Please Enter valid vpaSubString ", {
                    variant: "error"
                  });
                  return;
                }
                if (mcc === undefined || mcc.length < 4) {
                  enqueueSnackbar("Please Enter valid MCC", {
                    variant: "error"
                  });
                  return;
                }
              }
              if (
                (ServiceProvider === "IDFC" && servicetype === "PAYIN") ||
                servicetype === "VAN-UPI"
              ) {
                if (mcc === undefined || mcc.length < 4) {
                  enqueueSnackbar("Please Enter valid MCC", {
                    variant: "error"
                  });
                  return;
                }
              }

              if (
                method !== "manual" &&
                servicetype === "PAYIN" &&
                ServiceProvider === "NPST"
              ) {
                if (
                  settlementArray === undefined ||
                  settlementArray.length < 1
                ) {
                  enqueueSnackbar("Please Enter settlement values", {
                    variant: "error"
                  });
                  return;
                }
              }

              console.log(
                "voucherBusinessType",
                voucherBusinessType,
                voucherServiceType
              );

              if (
                ServiceProvider === "NEOKRED" &&
                servicetype === "VOUCHER" &&
                voucherBusinessType === "b2c"
              ) {
                if (!voucherServiceType) {
                  enqueueSnackbar("Please Select the Voucher Program", {
                    variant: "error"
                  });
                  return;
                }
              }

              if (ServiceProvider === "NEOKRED" && servicetype === "VOUCHER") {
                if (!settlementChargesTest) {
                  enqueueSnackbar("Please Enter Valid rate", {
                    variant: "error"
                  });
                  return;
                }
              }
              let accDetails = {};
              if (
                ServiceProvider === "NEOKRED" &&
                servicetype === "VOUCHER" &&
                voucherBusinessType === "b2b"
              ) {
                if (!remitterAccountNumber) {
                  enqueueSnackbar("Please enter remitter account number", {
                    variant: "error"
                  });
                  return;
                }
                if (!remitterAccountIfsc) {
                  enqueueSnackbar("Please enter remitter account ifsc", {
                    variant: "error"
                  });
                  return;
                }
                accDetails = {
                  remitterAccountNumber: remitterAccountNumber ?? "",
                  remitterIfscCode: remitterAccountIfsc ?? ""
                };
              }

              if (
                // type !== "" &&
                serviceType !== "" &&
                serviceProviderRate !== "" &&
                reseller !== "" &&
                resellerRate !== "" &&
                neokredRate !== "" &&
                clientRate !== ""
              ) {
                let obj = [];

                if (type === "FLAT") {
                  obj.push(flatData);
                }

                let ServiceProvider =
                  reduxData?.service?.serviceProviderName?.toUpperCase();

                let obj1 = {
                  resellerRate: resellerRate,
                  neokredRate: neokredRate,
                  comissionType: type,
                  comissionRate: type === "FLAT" ? [flatData] : clientRate,
                  serviceProviderRate: reduxData?.service?.serviceProviderRate,
                  serviceType: reduxData?.service?.serviceType,
                  serviceProviderName: reduxData?.service?.serviceProviderName,
                  notifyUrl: reduxData?.service?.notifyUrl ?? "",
                  zyroUserId: ServiceProvider === "ZYRO" ? zyroUserId : "",
                  zyropass: ServiceProvider === "ZYRO" ? zyropass : "",
                  vpaSubString: ServiceProvider === "FINO" ? vpaSubString : "",
                  mcc:
                    ServiceProvider === "FINO" ||
                    (ServiceProvider === "IDFC" && servicetype === "PAYIN") ||
                    servicetype === "VAN-UPI"
                      ? mcc
                      : "",
                  program:
                    ServiceProvider === "NEOKRED"
                      ? voucherBusinessType === "b2c"
                        ? voucherServiceType
                        : "axis"
                      : "",
                  voucherBusinessType:
                    ServiceProvider === "NEOKRED" ? voucherBusinessType : ""
                };
                console.log(obj1, "frst condition");
                if (servicetype === "VAN" && ServiceProvider === "EQUITAS") {
                  obj1.internal = isInternal;
                }

                if (
                  servicetype === "VAN" &&
                  (ServiceProvider === "AXIS" || ServiceProvider === "IDFC")
                ) {
                  obj1.onDemandSettlement = onDemandSettlement;
                  obj1.settleToAccount = settleToAccount;
                }
                if (ServiceProvider !== "NEOKRED") {
                  obj1.mechanism =
                    ServiceProvider === "KOPAY" ||
                    ServiceProvider === "NPST" ||
                    ServiceProvider === "FINO" ||
                    ServiceProvider === "1PAY"
                      ? mechanism
                      : (ServiceProvider === "AXIS" ||
                          ServiceProvider === "IDFC" ||
                          ServiceProvider === "EQUITAS") &&
                        reduxData?.service?.serviceType?.toUpperCase() === "VAN"
                      ? ["van"]
                      : ServiceProvider === "IDFC" &&
                        reduxData?.service?.serviceType?.toUpperCase() ===
                          "PAYIN"
                      ? ["qr"]
                      : mechanism2;
                }

                if (
                  ServiceProvider === "NEOKRED" &&
                  servicetype === "VOUCHER"
                ) {
                  obj1.settlementCharges = settlementCharges;
                }

                // SENDING_SERVICE
                if (
                  (ServiceProvider === "AXIS" ||
                    ServiceProvider === "CASHFREE") &&
                  servicetype === "PAYOUT"
                ) {
                  obj1.prefundUrl = prefundUrl;

                  // obj1.comissionRate = commissionData;
                  obj1.comissionType = Array.isArray(genericCommission)
                    ? "slab"
                    : genericCommission?.type;
                  obj1.preFundCommissionMode = currentVal;

                  if (currentVal === "generic") {
                    // console.log(genericCommission, "genericCommission----at-commissionOnPayment")
                    // obj1.comissionType = Array.isArray(genericCommission) ? 'slab' : genericCommission?.type;
                    obj1.commissionRate = genericCommission;
                  }
                  if (currentVal === "commission_on_transaction") {
                    obj1.comissionType = currentVal;
                    obj1.commissionRate = commissionData;
                  }
                }

                // CONDTION FOR SETTLEMENT
                if (
                  reduxData?.service?.serviceType?.toUpperCase() === "PAYIN" &&
                  reduxData?.service?.serviceProviderName?.toUpperCase() ===
                    "NPST"
                ) {
                  console.log(settlementArray, "TRY");
                  console.log(method, "METHOD");

                  console.log(settlementValue, "VALUE");

                  console.log(reduxData?.service, "kjdsfhjksdlfhdslkjljkdlkjf");

                  let set = {};
                  if (method === SETTLEMENT_HOURLY) {
                    // Extract the value from hourlySettlements array
                    const hourlySettlementValue =
                      settlementValue?.hourlySettlement || null;

                    // Set the settlement object accordingly for hourly type
                    set = {
                      method: method,
                      hourlySettlement: hourlySettlementValue
                    };
                  } else if (method === SETTLEMENT_CYCLES) {
                    // Set the settlement object accordingly for cycles type
                    set = {
                      method: method,
                      cycles: settlementArray
                    };
                  } else if (method === SETTLEMENT_TPLUSONE) {
                    const tPlusOne = settlementValue?.tPlusOneTime || null;

                    set = {
                      method: method,
                      tPlusOneTime: tPlusOne
                    };
                  } else if (method === SETTLEMENT_INSTANT) {
                    let comissionRate;
                    if (settlementArray.settlementCommission.length > 0) {
                      comissionRate = settlementArray.settlementCommission;
                    } else {
                      comissionRate = [settlementValue.flatSettlementData];
                    }

                    set = {
                      method: method,
                      comissionType: settlementArray.comissionType,
                      comissionRate: comissionRate
                    };
                  } else {
                    set = {
                      method: method
                    };
                  }

                  obj1.settlementDetails = set;
                }
                // console.log(obj1.settlement, "OBJ1_SETTLEMENT");

                // console.log(mechanism, "mechanism");

                // console.log(obj1, "object");

                if (ServiceProvider === "ZYRO") {
                  if (obj1?.mechanism.includes("van")) {
                    if (zyroUserId === "" || zyropass === "") {
                      enqueueSnackbar("Please fill all fields", {
                        variant: "error"
                      });
                      return;
                    }
                  }
                }
                //this condition ensures that at least two mechanisms are there

                if (
                  reduxData?.service?.serviceType?.toLowerCase() === "payin" &&
                  reduxData?.service?.serviceProviderName?.toLowerCase() !==
                    "idfc"
                ) {
                  if (mechanism.length === 0 || mechanism.length > 1) {
                    enqueueSnackbar("Please select  one Mechanism", {
                      variant: "error"
                    });
                    return;
                  }
                }
                //validation for comisssion transcation mode
                const validateTransactionArray = (array, arrayName) => {
                  if (!array || array.length === 0) {
                    enqueueSnackbar(`${arrayName} cannot be empty`, {
                      variant: "error"
                    });
                    return false;
                  }

                  for (const item of array) {
                    if (item.commissionType === "flat") {
                      if (item.percentage <= 0 && item.flatAmount <= 0) {
                        enqueueSnackbar(
                          `For 'flat' commission type in ${arrayName}, either percentage or flat amount must be greater than 0`,
                          { variant: "error" }
                        );
                        return false;
                      }
                    } else if (item.commissionType === "slab") {
                      if (item.minAmount <= 0 || item.maxAmount <= 0) {
                        enqueueSnackbar(
                          `For 'slab' commission type in ${arrayName}, both 'minAmount' and 'maxAmount' must be greater than 0`,
                          { variant: "error" }
                        );
                        return false;
                      }
                    } else {
                      enqueueSnackbar(
                        `Invalid commission type in ${arrayName}`,
                        {
                          variant: "error"
                        }
                      );
                      return false;
                    }
                  }

                  return true;
                };

                if (
                  ServiceProvider === "CASHFREE" &&
                  servicetype === "PAYOUT"
                ) {
                  if (!currentVal) {
                    enqueueSnackbar("Please select comission", {
                      variant: "error"
                    });
                    return;
                  }
                  if (!cashfreMerchantId) {
                    enqueueSnackbar("Please Enter Cashfree merchant ID", {
                      variant: "error"
                    });
                    return;
                  }
                  if (currentVal === "generic") {
                    if (
                      genericCommission.commissionType?.toLowerCase() === "flat"
                    ) {
                      if (
                        genericCommission.percentage <= 0 &&
                        genericCommission.flatAmount <= 0
                      ) {
                        enqueueSnackbar(
                          "For 'flat' commission type, either percentage or flat amount must be greater than 0",
                          {
                            variant: "error"
                          }
                        );
                        return;
                      }
                    } else if (
                      genericCommission.commissionType?.toLowerCase() === "slab"
                    ) {
                      if (
                        genericCommission.minAmount <= 0 ||
                        genericCommission.maxAmount <= 0
                      ) {
                        enqueueSnackbar(
                          "For 'slab' commission type, both 'from' and 'to' amounts must be greater than 0",
                          {
                            variant: "error"
                          }
                        );
                        return;
                      }
                    } else {
                      enqueueSnackbar("Please fill all fields", {
                        variant: "error"
                      });
                      return;
                    }
                  }
                  if (currentVal === "commission_on_transaction") {
                    if (
                      !validateTransactionArray(impsArray, "IMPS") ||
                      !validateTransactionArray(rtgsarray, "RTGS") ||
                      !validateTransactionArray(neftArray, "NEFT") ||
                      !validateTransactionArray(iftArray, "IFT") ||
                      !validateTransactionArray(upiArray, "UPI")
                    ) {
                      return;
                    }
                  }

                  obj1.cashfree_merchant_id = cashfreMerchantId;
                  obj1.cashfree_fundsource_id = cashfreFundSourceId;
                }

                onClickNext({
                  userRefId: reseller?.value,
                  resellerName: reseller?.label,
                  rootReferenceId: reseller?.userRefId,
                  service: obj1,
                  createdBy: JSON.stringify(createdBy),
                  ...accDetails
                });
              } else {
                enqueueSnackbar("Please fill all the fields", {
                  variant: "error"
                });
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ServiceRate;
const styles = {
  title: {
    fontSize: "24px",
    backgroundImage: " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
    backgroundSize: "100%",
    WebkitBackgroundClip: "text",
    MozBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    MozTextFillColor: "transparent",
    fontWeight: "600",
    width: "fit-content"
  },
  p: {
    color: "#6C6B6B",
    fontWeight: "400",
    fontSize: "14px"
  },
  label: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: "#1E2234"
  },
  cancel: {
    width: "56px",
    height: "19px",
    border: "1px solid #38369C",
    borderRadius: "8px"
  },
  select: {
    fontWeight: "400",
    fontSize: "16px",
    color: "#001053"
  }
};
